import { apiGet } from "@/modules/client/services/index";

export const RentService = {
  index() {
    return apiGet("/api/client/rent");
  },
};
